import React, { useState } from "react";

const faqData = [
  {
    q: "What exactly is a business ecosystem?",
    a: "Unlike standalone software, a business ecosystem like Beentara completely connects your website, operations, workforce management, and AI tools into a single, synchronized environment where data flows seamlessly.",
  },
  {
    q: "Is it hard to migrate my existing data to Beentara?",
    a: "Our dedicated onboarding team and import tools make transitioning from legacy spreadsheets and fragmented tools straightforward and secure.",
  },
  {
    q: "Can I upgrade my plan as my business grows?",
    a: "Absolutely. Beentara is built to scale. You can seamlessly transition between plans as your operational needs expand.",
  },
  {
    q: "How does the built-in AI actually help my day-to-day operations?",
    a: "Embedded AI helps automate data entry, generate professional content, route workflows intelligently, and provide actionable analytics without needing a separate data science tool.",
  },
];

export default function FaqSection() {
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <section className="saas-lp-section saas-lp-section--faq">
      <div className="saas-lp-inner saas-lp-faq">
        <h2>Frequently Asked Questions</h2>

        <div className="saas-lp-faq__list">
          {faqData.map((faq, idx) => (
            <div
              key={faq.q}
              className={`saas-lp-faq__item${openFaq === idx ? " saas-lp-faq__item--open" : ""}`}
            >
              <button
                type="button"
                className="saas-lp-faq__question"
                onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                aria-expanded={openFaq === idx}
              >
                {faq.q}
                <span className="saas-lp-faq__toggle" aria-hidden="true">+</span>
              </button>
              {openFaq === idx && <div className="saas-lp-faq__answer">{faq.a}</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
